module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "file_022"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "file_022"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("Grumman’s first fighter was so unique and revolutionary that the company built a model to wow the navy brass. The life-size mock-up, made of wood, was open on the back side to allow viewers to see the inner workings of the plane. Note the gunner’s station in the rear cockpit. "), _c('em', [_vm._v("Grumman History Center")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d1f828b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_022.vue
// module id = 117
// module chunks = 0